import {Application} from '../../backend/interfaces/application';
import {Reminder} from '../../backend/interfaces/reminder';
import {UserPublicInfo} from '../../backend/responses/user-public-info';

export interface AuxiliaryDataCacheContextState {
  applications: {
    [id: string]: Application;
  };
  reminders: {
    [id: string]: Reminder;
  };
  users: {
    [id: string]: UserPublicInfo;
  };
}

export enum AuxiliaryDataCacheContextActionType {
  SET_APPLICATIONS = 'SET_APPLICATIONS',
  SET_REMINDERS = 'SET_REMINDERS',
  SET_USERS = 'SET_USERS',
  CLEAR_ALL = 'CLEAR_ALL',
}

export type AuxiliaryDataCacheContextAction =
  | {
      type: AuxiliaryDataCacheContextActionType.SET_APPLICATIONS;
      applications: {
        [id: string]: Application;
      };
    }
  | {
      type: AuxiliaryDataCacheContextActionType.SET_REMINDERS;
      reminders: {
        [id: string]: Reminder;
      };
    }
  | {
      type: AuxiliaryDataCacheContextActionType.SET_USERS;
      users: {
        [id: string]: UserPublicInfo;
      };
    }
  | {
      type: AuxiliaryDataCacheContextActionType.CLEAR_ALL;
    };

export interface AuxiliaryDataCacheContextType {
  state: AuxiliaryDataCacheContextState;

  // Methods
  setApplications: (applications: {[id: string]: Application}) => void;
  setReminders: (reminders: {[id: string]: Reminder}) => void;
  setUsers: (users: {[id: string]: UserPublicInfo}) => void;
  clearAll: () => void;
}
